import React from 'react'
import Hero from '../components/Hero'
import Banner from '../components/Banner'

import {Link} from 'react-router-dom'

import Services from '../components/Services'
import FeaturedRooms from '../components/FeaturedRooms'


export default function Home() {
    return (
        <div>
            <Hero>
                <Banner title="Beach ressources" subtitle="luxurious rooms">
                    <Link to="/rooms" className="btn-primary">
                        our rooms
                    </Link>
                </Banner>
            </Hero>
            <Services />
            <FeaturedRooms />
        </div>
    )
}
